export const initialState = {
  transfers: [],
  count: 0
};
